module.exports = __webpack_public_path__ + "img/VGB.2a63a6fa.svg";